<template>
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5">
        <path d="M9.41 9.41a2 2 0 0 1-2.82-2.82" />
        <path d="M6.34 3.65A6.3 6.3 0 0 1 8 3.5c4 0 6.5 4.5 6.5 4.5a10.7 10.7 0 0 1-1.77 2.35M4.73 4.73C2.9 5.95 1.5 8 1.5 8s2.5 4.5 6.5 4.5a6.3 6.3 0 0 0 3.27-.93" />
        <path d="m2 2 12 12" />
    </svg>
</template>

<script lang="ts" setup vapor>
defineOptions({ name: 'EyeOffIcon' });
</script>
